(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Initialize slick with custom arrows
  $('.product-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><span class="visually-hidden">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"><span class="visually-hidden">Next</span></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
